import { createContext } from "react";

export const ExperimentContext = createContext({});
